module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("© 2012 The Howard Zinn Revocable Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("Introduction © 2012 by Anthony Arnove")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("Published in 2012 by")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("Haymarket Books")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("PO Box 180165")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("Chicago, IL 60618")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("www.haymarketbooks.org")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("773-583-7884")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("ISBN: 978-1-60846-228-5")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("Trade distribution:")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("In the US, Consortium Book Sales and Distribution, www.cbsd.com")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("In Canada, Publishers Group Canada, www.pgcbooks.ca")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("In the UK, Turnaround Publisher Services, www.turnaround-uk.com")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("In Australia, Palgrave Macmillan, www.palgravemacmillan.com.au")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("All other countries, Publishers Group Worldwide, www.pgw.com")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("Cover design by Abby Weintraub. Photo courtesy of the estate of Howard Zinn.")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("Published with the generous support of Lannan Foundation")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("and the Wallace Global Fund.")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("Library of Congress cataloging-in-publication data is available.")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "sgc-1"
  }, [_c('span', [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ff5c81c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Flow_0_0002.vue
// module id = 66
// module chunks = 0